import $ from 'jquery';
import Page from './page';
import Swiper from 'swiper';
import { initializeSlider } from './landing_page/initialize_slider';
import { initializeLinkListSliderSections } from './landing_page/initialize_link_list_slider_sections';
import { setInitialStates } from './landing_page/set_initial_states';
import { initializePageModules } from './landing_page/initialize_page_modules';
import { initializeMoreButtons } from '../_modules/sections/review_headline_text_actions/initialize_more_buttons';
import { showAction as showFsLightboxAction } from '../_flux/actions/fs_home_page_light_box_actions';
import { init as initFsLightBoxView } from '../_views/landing_fs_lightbox/landing_fs_lightbox_view';
import { init as initUiLock } from '../_views/ui_lock/ui_lock_view';
import loadQualieTestimonials from '../utilities/qualie';
import TyreSizeCalculator from '../utilities/tyre_size_calculator';
import { fetchCmsVariables } from '../_modules/cms/get_variables';
import initializeTargetComponent from '../_views/initialize_component';
import { initCmsLightboxContainer } from './landing_page/initialize_lightbox';
import { setPreselectFS } from '../_flux/helper/requests/preselect_fs';
import { init as initSelectFSLightBox } from '../_views/select_fs_light_box/select_fs_light_box_view';
import { showAction as showSelectFsLightboxAction, showErrorAction as showSelectFsErrorLightboxAction } from '../_flux/actions/select_fs_light_box_actions';
import { hideAction as unlockUi, showAction as lockUi } from '../_flux/actions/ui_lock_actions';
import vehicleRecommendedProducts from '../utilities/vehicle_recommended_products';
import TyreSizeFormatter from '../utilities/tyre_size_formatter';
import CatalogContainersConstants from './catalog/initialize_page_modules/catalog_container_constants';
import { setInitialState } from './catalog/set_initial_state';
import { init as initNotifyMe } from '../_views/notify_me/notify_me';
import { init as initOpenShippingQuote } from '../_views/catalog_postcode/catalog_postcode';
import { init as initFreeMobileFittingLightbox } from '../_views/free_mobile_fitting_light_box/free_mobile_fitting_light_box';
import { init as initCatalogDeliveryInfoLightBox } from '../_views/catalog_delivery_info_light_box/catalog_delivery_info_light_box';

export default class LandingPage extends Page {
    static _name = 'OrderTrackingPage';

    init() {
        super.init();
        initializeSlider();
        initializeLinkListSliderSections();
        initializeMoreButtons();

        const catalogRevampAdsContainer = document.getElementById(CatalogContainersConstants.CMS_ADS_CONTAINER_ID);
        if (catalogRevampAdsContainer) {
            /**
             *
             * initialize lightbox components afterwards
             *
             */
            const staticUrl = TYROOLA.globals.staticUrl;
            const baseUrl = TYROOLA.globals.baseUrl;

            const notifyMeContainer = document.getElementById(CatalogContainersConstants.NOTIFY_ME_CONTAINER_ID);
            initNotifyMe(notifyMeContainer);

            const uiLockContainer = document.getElementById(CatalogContainersConstants.CATALOG_UI_LOCK_CONTAINER_ID);
            initUiLock(uiLockContainer);

            const catalogShippingQuoteContainer = document.getElementById(CatalogContainersConstants.CATALOG_SHIPPING_QUOTE_CONTAINER_ID);
            initOpenShippingQuote(catalogShippingQuoteContainer);

            const freeMobileFittingLightBoxContainer = document.getElementById(CatalogContainersConstants.FREE_MOBILE_FITTING_LIGHT_BOX_CONTAINER_ID);
            const freeMobileFittingLightboxOptions = { staticUrl, baseUrl };
            initFreeMobileFittingLightbox(freeMobileFittingLightBoxContainer, freeMobileFittingLightboxOptions);

            const catalogDeliveryInfoLightBox = document.getElementById(CatalogContainersConstants.CATALOG_DELIVERY_INFO_LIGHT_BOX_CONTAINER_ID);
            const catalogDeliveryInfoLightBoxOptions = { staticUrl, baseUrl };
            initCatalogDeliveryInfoLightBox(catalogDeliveryInfoLightBox, catalogDeliveryInfoLightBoxOptions);

            setInitialState(true);
        }

        setInitialStates();
        initializePageModules('tyre', TYROOLA.globals.staticUrl);
        initCmsLightboxContainer();
        this.initFsLightboxTriggers();
        this.initContentToggles();
        loadQualieTestimonials(() => {
            fetchCmsVariables();
        });

        initSelectFSLightBox(document.getElementById('select-fs'), {});

        const { filterOptions } = TYROOLA.initialFluxStates.filter;
        const tyreSizeCalculator = new TyreSizeCalculator(TYROOLA.globals.baseUrl, filterOptions);
        tyreSizeCalculator.init();
        this.initFoldedContent();
        this.initStickyElement('.header-section-configurator-ribbon', '.header-section-configurator-ribbon-sticky');
        this.configuratorStickyRibbonHandler();
        this.setVehicleCtaLink();
        vehicleRecommendedProducts();

        return this;
    }

    setVehicleCtaLink() {
        if (location.pathname.indexOf('/vehicles/') !== -1 && location.pathname.indexOf('/tyres/') !== -1) {
            const ctaLinks = document.querySelectorAll('a[href="/v1/tyre/#tyre-size-from-url"]');
            ctaLinks.forEach(link => {
                link.href = `/v1/tyre/${location.pathname.substring(location.pathname.indexOf('/tyres/') + 7)}`;
            });

            const heading = document.querySelector(".link-list-sliders__headline");
            const tyreSize = location.pathname.substring(location.pathname.indexOf('/tyres/') + 7).replace(/\/$/, '');
            const formattedTyreSize = TyreSizeFormatter.format(tyreSize);
            heading.innerHTML = heading.innerHTML.replace("|formatted-tyre-size-from-url|", formattedTyreSize);
        }

        return this;
    }
    
    configuratorStickyRibbonHandler() {
        const elem = document.querySelector('.header-section-configurator-ribbon-sticky-mobile');
        if ($(window).width() < 1000 && elem) {
            const expandedElem = document.querySelector('.header-section-configurator-ribbon-sticky');
            const expandedTextElem = expandedElem.querySelector('.header-section-configurator-ribbon-text').parentElement;
            const arrowDownElem = expandedElem.querySelector('.header-section-configurator-ribbon-arrow-down');
            const resetElem = expandedElem.querySelector('.header-section-configurator-ribbon-reset');
            
            elem.addEventListener('click', () => {
                elem.style.opacity = 0;
                elem.style.display = 'none';
                
                expandedElem.style.display = 'block';
                expandedElem.style.opacity = 1;
                expandedElem.style.left = '';
                expandedElem.style.top = '20px';
                expandedElem.style.width = '335px';
                
                arrowDownElem.style.display = 'block';
                
                resetElem.style.right = '25px';
            });
            
            expandedTextElem.addEventListener('click', () => {
                expandedElem.style.opacity = 0;
                expandedElem.style.left = 'calc(50% - 480px)';
                expandedElem.style.top = '';
                expandedElem.style.width = '';
                expandedElem.style.display = 'none';
                
                elem.style.display = 'block';
                elem.style.opacity = 1;

                arrowDownElem.style.display = 'none';

                resetElem.style.right = '';
            });
        }

        return this;
    }
    
    initStickyElement(selector, stickySelector) {
        document.addEventListener('scroll', () => {
            const elem = document.querySelector(selector);
            const stickyElem = document.querySelectorAll(stickySelector);

            if (elem) {
                const isVisible = this.isScrolledIntoView(elem);
                if (isVisible) {
                    elem.style.opacity = 1;
                    stickyElem.forEach(e => {
                        e.style.top = '-150px';
                        e.style.opacity = 0;
                        e.style.height = '0px';
                    });
                } else {
                    elem.style.opacity = 0;
                    stickyElem.forEach((e, idx) => {
                        e.style.top = '20px';
                        e.style.opacity = 1;
                        e.style.height = idx === 1 ? '56px' : $(window).width() > 1000 ? '76px' : 'auto';
                    });
                }
            }
        });

        return this;
    }

    isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        
        var element = $(elem);
        if (element && element.offset() && element.offset().top) {
            var elemTop = element.offset().top;
            var elemBottom = elemTop + element.height();

            return elemBottom >= docViewTop;
        }
        return false;
    }
    
    initFoldedContent() {
        const readMoreLinks = document.querySelectorAll('.folded-content-read-more');
        readMoreLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                link.style.display = 'none';
                const foldedContentElement = link.previousElementSibling;
                if (foldedContentElement && foldedContentElement.classList.contains('folded-content')) {
                    foldedContentElement.classList.remove('folded-content');
                }
            });
        });

        return this;
    }

    initFsLightboxTriggers() {
        const FsLightBoxContainerElement = document.getElementById('fs-home-page-light-box-container');
        // ui lock when loading catalog
        const uiLockContainerElement = document.getElementById('ui-lock-container');
        initUiLock(uiLockContainerElement);

        initializeTargetComponent(
            '.js-open-fs-lightbox',
            initFsLightBoxView.bind(this, FsLightBoxContainerElement, {}),
            showFsLightboxAction,
        );
        initializeTargetComponent(
            'a[href="#open-fs-lightbox"]',
            initFsLightBoxView.bind(this, FsLightBoxContainerElement, {}),
            showFsLightboxAction,
        );

        return this;
    }

    /**
     * @returns {LandingPage}
     */
    initContentToggles() {
        const $toggleHeaders = $('.product-toggle__header');
        const dataFsid = $('button[data-fsid]');

        dataFsid.on('click', async (e) => {
            e.stopPropagation();
            e.preventDefault();
            lockUi();
            const fsId = e.currentTarget.dataset.fsid;
            const response = await setPreselectFS({ fsId });
            if (response && !response.error) {
                const title = e.currentTarget.parentElement.parentElement.firstElementChild.textContent;
                showSelectFsLightboxAction({ title });
            } else {
                const error = response?.error?.userMessage || '';
                showSelectFsErrorLightboxAction({ error });
            }
            unlockUi();
            return false;
        });

        $toggleHeaders.on('click', function (e) {
            const $toggle = $(this).parent();

            if (!$toggle.hasClass('product-toggle--opened')) {
                let $openedToggles = $toggle.parent().find('.product-toggle--opened');
                $openedToggles.each(function () {
                    const openedToggle = $(this);
                    const openedToggleContent = $openedToggles.find('.product-toggle__content');

                    openedToggleContent.slideToggle();
                    openedToggle.removeClass('product-toggle--opened');
                });
            }
            $('+ .product-toggle__content', this).slideToggle();
            $toggle.toggleClass('product-toggle--opened');
        });

        $('.product-toggle')
            .find('.default-opened')
            .each(function () {
                if ($(this).is(':visible')) {
                    $(this).trigger('click');
                }
            });
        return this;
    }
}
